<div class="chat-head-{{{o.type}}} chat-head row no-gutters">
    <a class="restore-chat w-100 align-self-center" title="{{{o.tooltip}}}">
        {[ if (o.num_unread) { ]}
            <span class="message-count badge badge-light">{{{o.num_unread}}}</span>
        {[ } ]}
        {{{o.title}}}
    </a>
    <a class="chatbox-btn close-chatbox-button fa fa-times"></a>
</div>
